//components/Login.js
import React, { useState } from "react";
import { login } from "../services/api";
import { useNavigate } from "react-router-dom";
import logo from "../assets/images/itup_logo.png";
import { Container, TextField, Button, Typography, Box, Paper, Alert } from "@mui/material";
import { getUserRole } from "../services/getUserRole";

const Login = ({ setAuth }) => {
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [error, setError] = useState("");
	const navigate = useNavigate();

	const handleLogin = async (e) => {
		e.preventDefault();
		try {
			const data = await login(username, password);
			localStorage.setItem("token", data.token);
			setAuth(true);
			let role = getUserRole();
			if (role === "customer") {
				navigate("/dashboard");
			} else {
				navigate("/dashboard");
			}
		} catch (err) {
			setError("Usuário ou senha inválidos");
		}
	};

	return (
		<Container
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				height: "100vh",
			}}
			maxWidth="xs"
		>
			<img style={{ width: "20rem", justifySelf: "center" }} src={logo} />
			<Paper
				style={{
					borderRadius: "20px",
					padding: "20px",
					display: "flex",
					alignItems: "center",
					justifyContent: "unset",
					flexDirection: "column", // Garante que os elementos fiquem em coluna
				}}
				elevation={3}
				sx={{ p: 4, mt: 8, textAlign: "center" }}
			>
				<Typography
					style={{
						fontWeight: "bold",
						textShadow: "2px 2px 4px rgba(0, 0, 0, 0.3)",
					}}
					variant="h4"
					gutterBottom
				>
					Config Rental
				</Typography>
				{error && (
					<Alert severity="error" sx={{ mb: 2 }}>
						{error}
					</Alert>
				)}
				<Box component="form" onSubmit={handleLogin}>
					<TextField
						slotProps={{
							input: { style: { borderRadius: "12px" } }, // Aplica ao input
						}}
						fullWidth
						label="Usuário"
						variant="outlined"
						margin="normal"
						value={username}
						onChange={(e) => setUsername(e.target.value)}
						required
					/>
					<TextField
						slotProps={{
							input: { style: { borderRadius: "12px" } },
						}}
						fullWidth
						label="Senha"
						type="password"
						variant="outlined"
						margin="normal"
						value={password}
						onChange={(e) => setPassword(e.target.value)}
						required
					/>
					<Button
						style={{
							borderRadius: "12px",
							paddingLeft: "22%",
							paddingRight: "22%",
							fontWeight: "bold",
						}}
						variant="contained"
						color="primary"
						type="submit"
						sx={{ mt: 2 }}
					>
						Entrar
					</Button>
				</Box>
			</Paper>
		</Container>
	);
};

export default Login;
